import { GET_LABELS, POST_LABEL, PUT_LABEL } from '../actionTypes'
import { Label } from '../reducers/label'

export const getLabelsAction = (labels: Label[]) => ({ type: GET_LABELS, payload: labels })
export const createLabelAction = (label: Label) => ({ type: POST_LABEL, payload: label })
export const updateLabelAction = (label: Label) => ({ type: PUT_LABEL, payload: label })
